export default "skymp5-front/f34e00e727588c3bf1788750e373ee20.png";